import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useTenantStore = defineStore('tenant', () => {
  // State
  const currentTenantId = ref<string | null>(null)

  // Actions
  function setCurrentTenant(tenantId: string) {
    currentTenantId.value = tenantId
  }

  return {
    currentTenantId,
    setCurrentTenant
  }
}, {
  persist: {
    key: 'tenant',
    paths: ['currentTenantId']
  }
})
